import BootScene from './scenes/BootScene';
import PreloadScene from './scenes/PreloadScene';
import LevelOneScene from './scenes/LevelOneScene';
import UIScene from './scenes/UIScene';
import { getSettings } from './systems/settings';

export function createGameConfig(parent) {
  const q = getSettings().graphicsQuality;
  const pixelArt = false;
  const antialias = q !== 'low';
  return {
    type: window.Phaser?.AUTO || 0,
    parent,
    backgroundColor: '#020617',
    scale: {
      mode: 3, // Phaser.Scale.FIT
      autoCenter: 1, // Phaser.Scale.CENTER_BOTH
      width: 1280,
      height: 720,
    },
    physics: {
      default: 'arcade',
      arcade: {
        gravity: { y: 900 },
        debug: false,
      },
    },
    render: { antialias, pixelArt, roundPixels: false },
    scene: [BootScene, PreloadScene, LevelOneScene, UIScene],
    dom: { createContainer: false },
    input: { activePointers: 3 },
  };
}

export const WORLDS = [
  { id: 'w1', nameKey: 'worlds.list.w1', unlocked: true, levels: ['l1'] },
  { id: 'w2', nameKey: 'worlds.list.w2', unlocked: false, levels: [] },
  { id: 'w3', nameKey: 'worlds.list.w3', unlocked: false, levels: [] },
  { id: 'w4', nameKey: 'worlds.list.w4', unlocked: false, levels: [] },
  { id: 'w5', nameKey: 'worlds.list.w5', unlocked: false, levels: [] },
  { id: 'w6', nameKey: 'worlds.list.w6', unlocked: false, levels: [] },
];
